// API URL: /api/courseapi/getcoursevariants/{pageNumber}/{pageId}/{language}
import Basket from '../modules/basket';

if ($('.courses-calendar-page').length > 0) {
    var getUrl = window.location,
        baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0],
        pageId = $('.courses-calendar-page').attr('data-pagetypeid'),
        pageNumber = 1,
        language = $('html').attr('lang'),
        calendarUrl = baseUrl + 'api/courseapi/getcoursevariants/'+ pageNumber + '/' + pageId + '/' + language,
        breakpoints = {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1260
        },
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        maxVisible = 10;

    if (viewportWidth < breakpoints.md) {
        maxVisible = 5;
    }
    if (viewportWidth < breakpoints.sm) {
        maxVisible = 3;
    }

    $.fn.toggleCalendarAccordion = function() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
        if (viewportWidth > breakpoints.lg) {
            $('#calendar-accordion .accordion-header').attr('data-toggle', '');
        } else {
            $('#calendar-accordion .accordion-item').each( function() {
                $(this).find('.accordion-header').attr('data-toggle', 'collapse');
            });
        }
    };


    // pagination
    $.fn.pagination = function (pages) {
        if (pages > 1 && pages < maxVisible) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: pages,
                wrapClass: 'pagination justify-content-center',
                next: '',
                prev: '',
                nextClass: 'hidden',
                prevClass: 'hidden',
                page: 1,
                firstLastUse: false,
            });
        } else if (pages > 1) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: maxVisible,
                wrapClass: 'pagination justify-content-center',
                next: '. . .',
                prev: '. . .',
                page: 1,
                firstLastUse: true,
                first: '',
                last: ''
            });
        } else {
            $('#pagination ul').remove();
        }
    };



    // Update list on pagination click
    $.fn.paginationClick = function() {
        $('#pagination').unbind('page').bootpag().on('page', function(event, pageNumber){
            calendarUrl = baseUrl + 'api/courseapi/getcoursevariants/'+ pageNumber + '/' + pageId + '/' + language;

            $.get(calendarUrl, function(data) {
                $('#calendar-accordion').html(data.Html);
                new Basket();
            });
            $(window).scrollTop(0);
        });
    };

    // initiate pagination listener
    $.fn.paginationClick();


    // get initial list on page 1
    $.get(calendarUrl, function(data) {
        $('#calendar-accordion').html(data.Html);
        $.fn.pagination(data.Pages);
        $.fn.toggleCalendarAccordion();
        new Basket();
    });

    // toggle accordion on device rotation
    $(window).resize(function() {
        $.fn.toggleCalendarAccordion();
    });
};


